const messages = {
  "setting.dashboard.title": "تنظیمات سیستم",

  "affiliation.type.title": "عنوان مجموعه",
  "affiliation.type.code": "کد دسته بندی",
  "affiliation.type.allowAddProfessor": "امکان اضافه کردن هیات علمی",

  "setting.field.langId": "انتخاب زبان",
  "setting.field.name": "نام فیلد",
  "setting.field.type": "نوع فیلد",
  "setting.field.category": "دسته بندی",
  "setting.field.category.new": "دسته بندی جدید",
  "setting.field.state": "وضعیت نمایش فیلد",
  "setting.field.new": "افزودن فیلد جدید",
  "setting.field.edit": "ویرایش فیلد",
  "setting.field.save": "ثبت فیلد",
  "setting.field.values": "مقادیر فیلد",
  "setting.field.enableForSearch": "محدودسازی گزارش",

  "setting.account.form": "تنظیمات فرم طرف حساب",
};

export default messages;
